<h2 class="subject">Terms Of Services</h2>

<div class="tos-paragraph">
  <p>
    You must be at least 18 to use this website. By using this website you confirm you are 18 years old or older. If the national legal gambling age is older in your country then
    that takes precedence and you should not be using this website. You can only create 1 account per person. Creating multiple accounts will be considered fraudulent and your
    account may be suspended based on your activity. Upon a manual review your balance may be taken away in such case. On an Account ban, SkinBet.gg reserves the right to not pay
    out the user's balance in extreme cases of Exploit / Scam
  </p>
</div>
<div class="tos-paragraph">
  <h3>Title of Section</h3>
  <p>
    You must be at least 18 to use this website. By using this website you confirm you are 18 years old or older. If the national legal gambling age is older in your country then
    that takes precedence and you should not be using this website.
    <br />
    <br />
    You can only create 1 account per person. Creating multiple accounts will be considered fraudulent and your account may be suspended based on your activity. Upon a manual
    review your balance may be taken away in such case. On an Account ban, SkinBet.gg reserves the right to not pay out the user's balance in extreme cases of Exploit / Scam
  </p>
</div>
<div class="tos-paragraph">
  <h3>Title of Section</h3>
  <p>
    You must be at least 18 to use this website. By using this website you confirm you are 18 years old or older. If the national legal gambling age is older in your country then
    that takes precedence and you should not be using this website. You can only create 1 account per person. Creating multiple accounts will be considered fraudulent and your
    account may be suspended based on your activity. Upon a manual review your balance may be taken away in such case. On an Account ban, SkinBet.gg reserves the right to not pay
    out the user's balance in extreme cases of Exploit / Scam
  </p>
</div>
<div class="tos-paragraph">
  <h3>Title of Section</h3>
  <p>
    You must be at least 18 to use this website. By using this website you confirm you are 18 years old or older. If the national legal gambling age is older in your country then
    that takes precedence and you should not be using this website.
    <br />
    <br />
    You can only create 1 account per person. Creating multiple accounts will be considered fraudulent and your account may be suspended based on your activity. Upon a manual
    review your balance may be taken away in such case. On an Account ban, SkinBet.gg reserves the right to not pay out the user's balance in extreme cases of Exploit / Scam
  </p>
</div>
